// extracted by mini-css-extract-plugin
export default {"gray-60":"rgb(105, 111, 119)","container":"styles_container__OogEW","secondaryHeading":"styles_secondaryHeading__GI1I0"};